import { Flag } from "@fidget/common/components/flag/flag";
import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { Country, countryService } from "@fidget/common/services/countries";
import { ControllerStateAndHelpers } from "downshift";
import { FieldState } from "formstate";
import React, { PropsWithChildren } from "react";
import styles from "./countryAutocomplete.css";

const CountryGrid = ({ item: { name, iso } }: { item: Country }) => (
  <div className={styles["country-row"]}>
    <Flag country={iso} />
    <span className={styles["country-name"]}>{name}</span>
  </div>
);

interface Props {
  field: FieldState<Partial<Country>>;
}

export const CountryAutocomplete = ({ field }: Props) => {
  const itemsProvider = (helpers: ControllerStateAndHelpers<Country>): Country[] => {
    const { inputValue } = helpers;
    return inputValue ? countryService.find(inputValue) : countryService.countries;
  };

  const itemToString = (item: PropsWithChildren<Country> | null) => (item ? item.name : "");

  const onInputValueChange = (val: string) => {
    const countryByName = countryService.countryByName(val);
    field.reset({
      name: val,
      ...countryByName,
    });
    field.validate();
  };

  const render = () => {
    return (
      <AutoComplete<Country>
        GridItem={CountryGrid}
        error={field.error}
        inputValue={field.$?.name || ""}
        styleType={"signup"}
        itemsProvider={itemsProvider}
        enableReset
        itemToString={itemToString}
        emptyPlaceholder={intl.formatMessage("profile.edit.noMatchingCountries")}
        placeholder={intl.formatMessage("signup.payment.placeholder.country")}
        onStateChange={(ev) => {
          // downshift.StateChangeTypes
          if (ev.inputValue !== undefined && ev.type !== "__autocomplete_blur_input__" && ev.type !== "__autocomplete_blur_button__") {
            onInputValueChange(ev.inputValue || "");
          }
        }}
      />
    );
  };

  return render();
};
